@for (option of options; track option.value; let i = $index) {
  <div class="form-check form-check-inline form-check-solid me-5 mt-3">
    <input id="{{name}}-{{option.name}}" class="form-check-input" name="{{name}}-{{option.name}}" type="checkbox"
    [value]="option.value" [(ngModel)]="checkedStatuses[i]" (ngModelChange)="onOptionSelectionChanged($event, option.value)"/>
    <label for="{{name}}-{{option.name}}" class="fw-bold ps-2 fs-6">
        {{option.name}}
    </label>
  </div>
}
